import DeleteIcon from '@mui/icons-material/Delete';
import UpdateIcon from '@mui/icons-material/Update';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Avatar, Box, Button, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip, Typography } from '@mui/material';
import { deleteObjectApi } from 'api/general';

import AddUpdateAgendaTemplateDialog from 'app/components/Dialog/AddUpdateAgendaTemplateDialog';
import AgendaTemplateItemDialog from 'app/components/Dialog/AgendaTemplateItemDialog';
import { getLocaleDateWithTimeCustomV2, getUserFullName, highlightText } from 'app/utils/appHelpers';
import { AGENDA_TEMPLATE } from 'app/utils/constants/customConstant';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAgendaTemplates } from 'stores/general';
import Swal from 'sweetalert2';
import config from '../../../../config';
import AgendaTemplateDataTableToolbar from './AgendaTemplateDataTableToolbar';

function AgendaTemplateDataTable({ mainData = [], column, pageTitle }) {
    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [updateInfoDialogStatus, setUpdateInfoDialogStatus] = useState(false);
    const [selectedAgendaTemplate, setSelectedAgendaTemplate] = useState();
    const [detailDialogStatus, setDetailDialogStatus] = useState(false);
    const [selectedDetailAgendaTemplate, setSelectedDetailAgendaTemplate] = useState();
    const userList = useSelector(state => state.user.data);
    const dispatch = useDispatch();
    const [highlightQuery, setHighlightQuery] = useState('');
    useEffect(() => {
        setData([...mainData]);
        setData2([...mainData]);
    }, [mainData]);

    const updateAfterTable = (item) => {
        let tmp = data;
        const index = data.findIndex(x => x.id === item.id);
        index !== -1 ? tmp[index] = item : tmp.push({ ...item, id: Number(data[data.length - 1].id) + 1 })
        setData([...tmp]);
        setData2([...tmp]);
        dispatch(setAgendaTemplates([...tmp]));
    }

    const addAfterTable = (agendaTemplate) => {
        let tmp = data;
        tmp.unshift(agendaTemplate);
        setData([...tmp]);
        setData2([...tmp]);

        dispatch(setAgendaTemplates([...tmp]));
    }

    const handleRequestSort = (event, property) => {
        const tempOrderBy = property;
        let tempOrder = 'desc';

        if (orderBy === property && order === 'desc') {
            tempOrder = 'asc';
        }
        const tempdata =
            tempOrder === 'desc'
                ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
                : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));

        setData(tempdata);
        setOrder(tempOrder);
        setOrderBy(tempOrderBy);
    };

    const DataTableHead = ({ onRequestSort, customColumnData }) => {
        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };

        return (
            <TableHead>
                <TableRow>
                    {customColumnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                align={column.numeric}
                                padding={column.disablePadding ? 'none' : 'normal'}
                                sx={{ whiteSpace: 'normal' }}
                            >
                                <Tooltip
                                    title="Sırala"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={createSortHandler(column.id)}
                                        sx={{ whiteSpace: 'normal', '& .MuiTableSortLabel-icon': { flexShrink: 0 } }}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    };

    const updateAgendaTemplateInfo = (agendaTemplate) => {
        setSelectedAgendaTemplate(agendaTemplate)
        setUpdateInfoDialogStatus(true)
    }

    const showAgendaTemplateDetail = (agendaTemplate) => {
        setSelectedDetailAgendaTemplate(agendaTemplate)
        setDetailDialogStatus(true)
    }

    const deleteItem = (item) => {
        Swal.fire({
            title: 'Silme İşlemi',
            text: "'" + item.title + "' başlıklı şablonu silmek istediğinizden emin misiniz?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet Sil',
            cancelButtonText: "Vazgeç"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const result = await deleteObjectApi(AGENDA_TEMPLATE, item.id);
                setData([...data.filter(x => x.id !== item.id)])
                setData2([...data2.filter(x => x.id !== item.id)])
                dispatch(setAgendaTemplates([...data.filter(x => x.id !== item.id)]));
                if (result.status) {

                    dispatch(setAgendaTemplates([...data.filter(x => x.id !== item.id)]));
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'İşlem başarılı.',
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            }
        })
    }

    

    return (
        <Paper className="col-md-12" sx={{ minWidth: 0, overflow: 'hidden' }}>
            <AgendaTemplateDataTableToolbar
                pageTitle={pageTitle}
                data2={data2}
                setData={setData}
                afterUpdateFunc={updateAfterTable}
                addAfterTable={addAfterTable}
                setHighlightQuery={setHighlightQuery}
            />

            <div className="flex-auto" style={{ minWidth: 0 }}>
                <Box sx={{ overflowX: 'auto' }}>
                    <Table
                        className=""
                        size='small'
                        sx={{
                            minWidth: 960,
                            '& .MuiTableCell-head': { whiteSpace: 'normal' },
                            '& .MuiTableSortLabel-root': { whiteSpace: 'normal' },
                            '& .MuiTableSortLabel-icon': { flexShrink: 0 },
                        }}
                    >
                        <DataTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={handleRequestSort}
                            rowCount={data.length}
                            customColumnData={column}
                        />
                        <TableBody>
                            {data.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={column.length} align="center" style={{ padding: '40px 16px' }}>
                                        <Typography variant="body1" color="textSecondary">
                                            Şablon bulunmamaktadır
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                    const user = userList.find(x => x.id === n.userId);
                                    return (
                                        <TableRow hover key={"trO" + n.id}>
                                            <TableCell align="left" padding="normal">
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <Avatar
                                                        alt=""
                                                        src={(user && user.profileImageUrl) ? config.userAuthApiUrl + user.profileImageUrl : config.userAuthApiUrl + config.defaultProfileImageUrl}
                                                        onError={(e) => { e.target.onerror = null; e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl }}
                                                    />
                                                    <span>{highlightText(getUserFullName(user), highlightQuery)}</span>
                                                </Box>
                                            </TableCell>

                                            <TableCell align="left" padding="normal">
                                                {highlightText(n.title, highlightQuery)}
                                            </TableCell>

                                            <TableCell align="left" padding="normal">
                                                {highlightText(n.body.length > 100 ? n.body.substring(0, 100) + '...' : n.body, highlightQuery)}
                                            </TableCell>

                                            <TableCell align="left" padding="normal">
                                                {getLocaleDateWithTimeCustomV2("tr", n.pdate)}
                                            </TableCell>

                                            <TableCell align="left" padding="none">

                                                <Tooltip style={{ width: 'auto' }} title="Şablon Güncelle">
                                                    <Button  key="one" onClick={() => updateAgendaTemplateInfo(n)}>
                                                        <UpdateIcon color='info' fontSize='small' />
                                                    </Button>
                                                </Tooltip>
                                                <Tooltip title="Şablon Sil" >
                                                    <Button  key="two" onClick={() => deleteItem(n)} >
                                                        <DeleteIcon color='error' fontSize='small' />
                                                    </Button>
                                                </Tooltip>



                                                <Tooltip style={{ width: 'auto' }} title="Detay">
                                                    <Button  key="three" onClick={() => showAgendaTemplateDetail(n)}>
                                                        <VisibilityIcon color='primary' fontSize='small' />
                                                    </Button>
                                                </Tooltip>

                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    count={data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={(e, page) => setPage(page)}
                                    onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                                    labelRowsPerPage={"Görüntülenecek Satır"}
                                    rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                                    showFirstButton
                                    showLastButton
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Box>
            </div>

            <AddUpdateAgendaTemplateDialog
                open={updateInfoDialogStatus}
                onClose={() => setUpdateInfoDialogStatus(false)}
                afterUpdateFunc={updateAfterTable}
                addAfterTable={addAfterTable}
                selectedAgendaTemplate={selectedAgendaTemplate}
            />

            {selectedDetailAgendaTemplate && (
                <AgendaTemplateItemDialog
                    open={detailDialogStatus}
                    onClose={() => setDetailDialogStatus(false)}
                    agendaTemplate={selectedDetailAgendaTemplate}
                />
            )}
        </Paper>
    )
}

export default AgendaTemplateDataTable 